import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import GroupIcon from '@mui/icons-material/Group';
import ProgressBar from 'src/components/ProgressBar';
import helpers from 'src/helpers';
import {
  COLOR_GREY_600,
  FONT_FAMILY,
} from 'src/constants/styleOptions';

const LITTLE_HIDDEN_COLOR = COLOR_GREY_600;

function SendingProgress({
  isSending = false,
  sentTo = 0,
  contactsCount = 0,
  isLittleHidden = false,
}) {
  const sentToNumber = useMemo(() => helpers.transform.toInt10(sentTo), [sentTo]);
  const contactsCountNumber = useMemo(() => helpers.transform.toInt10(contactsCount), [contactsCount]);
  const sentInPercentages = useMemo(() => {
    const resultInPercentages = !sentToNumber || !contactsCountNumber ? 0 : Math.round((sentToNumber / contactsCountNumber) * 100);

    return resultInPercentages > 100 ? 100 : resultInPercentages;
  }, [sentToNumber, contactsCountNumber]);

  return isSending && (
    <Box
      sx={{
        width: '100%',
        maxWidth: '145px',
        overflow: 'hidden',
        padding: '6px 0px 0px 0px',
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          fontSize: '12px',
          color: isLittleHidden ? LITTLE_HIDDEN_COLOR : '#0091EA',
          lineHeight: '18px',
          fontWeight: 500,
          fontFamily: FONT_FAMILY,
          whiteSpace: 'normal',
        }}
      >
        Sending progress...
      </Box>
      <ProgressBar
        currentValuePercentages={sentInPercentages}
        containerOptions={{
          paddingTop: '2px',
          paddingBottom: '2px',
        }}
        colorBar={isLittleHidden ? LITTLE_HIDDEN_COLOR : '#2CB3FF'}
      />
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'nowrap',
          width: '100%',
          overflow: 'hidden',
          fontSize: '12px',
          color: isLittleHidden ? LITTLE_HIDDEN_COLOR : '#B5B5B5',
          lineHeight: '18px',
          fontWeight: 500,
          fontStyle: 'italic',
          fontFamily: FONT_FAMILY,
        }}
      >
        <GroupIcon
          sx={{
            color: isLittleHidden ? LITTLE_HIDDEN_COLOR : '#B5B5B5',
            fontSize: '17px',
          }}
        />
        <Box
          sx={{
            padding: '0px 0px 0px 2px',
            whiteSpace: 'normal',
          }}
        >
          {`Sent To: ${sentToNumber.toLocaleString('en-US')} of ${contactsCountNumber.toLocaleString('en-US')}`}
        </Box>
      </Box>
    </Box>
  );
}

SendingProgress.propTypes = {
  isSending: PropTypes.bool,
  sentTo: PropTypes.number,
  contactsCount: PropTypes.number,
  isLittleHidden: PropTypes.bool,
};

export default SendingProgress;
